/**
 * OtpCodeValidEnum
 */
export enum OtpCodeValidEnum {
  "3DS000" = "3DS000",
  "OTP000" = "OTP000",
}



// WEBPACK FOOTER //
// ./src/shared/OtpCodeValidEnum.ts